module.exports = __webpack_public_path__ + "images/category_lp/retro_game/assessment_achievements/4@2x_06ad35d0c168e2cc21c78fa107836fb6.png";